import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Loads products+variants and lets parent pick a variant. Calls onPick(variantObj).
export function useVariants() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products", { params: { status: "active" } }).then((r) => setProducts(r.data)); }, []);
  const flat = [];
  products.forEach((p) => (p.variants || []).forEach((v) => flat.push({
    variant_id: v.id, product_id: p.id, product_name: p.name,
    pos_product_id: p.pos_product_id, pos_variant_id: v.pos_variant_id,
    color: v.color, size: v.size, sku: v.sku,
    purchase_price: parseInt(v.purchase_price || v.hpp_actual || v.hpp_estimate || 0) || 0,
    label: `${p.name} — ${v.color}/${v.size}`,
  })));
  return { products, flat };
}

export function VariantSelect({ flat, value, onChange, testId }) {
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="bg-white" data-testid={testId}><SelectValue placeholder="Pilih produk/varian" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {flat.map((f) => <SelectItem key={f.variant_id} value={f.variant_id}>{f.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
